import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { catchError, from, of, switchMap } from 'rxjs';
import { DealerFeature } from '..';
import { DealerApiService } from '../../api/dealer-api.service';
import { actions } from './home.actions';

@Injectable()
export class HomeEffects {
    protected readonly actions$ = inject(Actions);
    protected readonly store = inject(Store);
    protected readonly dealerApi = inject(DealerApiService);

    loadHome$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.loadHome),
            concatLatestFrom(() => this.store.select(DealerFeature.state.selectDealerSlug)),
            switchMap(([, dealerSlug]) =>
                from(this.dealerApi.getHomePage(dealerSlug)).pipe(
                    switchMap((home) => [
                        actions.loadHomeSuccess({
                            home,
                        }),
                    ]),
                    catchError((error) => of(actions.loadHomeFailure({ error }))),
                ),
            ),
        );
    });
}
